import { FunctionComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '../../tailwindcomponents';
import { SvgIcon } from '../icons/SvgIcon';
import { NavItem } from './navItems';

type SidebarNavItemProps = {
    item: NavItem,
    active: boolean,
    collapsed: boolean,
    /** Trailing status icon or badge, shown only when the label is visible. */
    trail?: ReactNode,
    /** Appended to the tooltip so a collapsed user still gets the status. */
    trailText?: string,
    /** Draws a dot on the icon in rail mode, where the trail is hidden. */
    showDot?: boolean,
}

const SidebarNavItem: FunctionComponent<SidebarNavItemProps> = ({
    item, active, collapsed, trail, trailText, showDot = false,
}) => (
    <li>
        {/* The Tooltip always renders and is merely disabled when expanded.
         * Conditionally wrapping would swap the element type on every row at the
         * same moment the width animation starts, remounting 26 subtrees. */}
        <Tooltip
            title={trailText ? `${item.label} - ${trailText}` : item.label}
            placement="right-start"
            type="primary"
            disabled={!collapsed}
        >
            <Link
                to={item.path}
                className="ds-nav-item"
                data-ds-active={active ? 'true' : undefined}
                aria-current={active ? 'page' : undefined}
            >
                <span className="ds-nav-icon">
                    <SvgIcon name={item.icon} size={18} />
                </span>
                <span className="ds-nav-label">{item.label}</span>
                {trail !== undefined && <span className="ds-nav-trail ml-auto flex items-center">{trail}</span>}
                {showDot && collapsed && <span className="ds-nav-dot" aria-hidden="true" />}
            </Link>
        </Tooltip>
    </li>
);

export default SidebarNavItem;
